import React from "react";
import {Stack, Typography} from "@mui/material";
import {IconDeviceDesktop} from "@tabler/icons-react";

export const MobileUnavailable = ({
                                      title = "Not available on mobile",
                                      subtitle = "This page is designed for larger screens. Please open it on a desktop device.",
                                  }) => (
    <Stack
        alignItems="center"
        justifyContent="center"
        gap={1.5}
        sx={{height: "calc(100dvh - 48px)", px: 4, textAlign: "center"}}
    >
        <IconDeviceDesktop size={48} stroke={1.5} color="#A3A39E"/>
        <Typography sx={{fontSize: 18, fontWeight: 600, color: "text.primary"}}>{title}</Typography>
        <Typography sx={{fontSize: 14, color: "text.secondary", maxWidth: 320}}>{subtitle}</Typography>
    </Stack>
);
